import { useQuery } from '@tanstack/react-query';

import { PayStation } from 'src/features/payment/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station/:payStationId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    payStationId: string;
}
const queryFn = ({ parkingId, payStationId }: DTO): Promise<PayStation> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, payStationId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPayStation, RESOURCE as GET_PAY_STATION_RESOURCE };
